<script>
import con from '@services/connection'
import { user } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import { getNumber, toMoney, toPercent } from '@utils/Format'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  components: {
    Title,
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      title: '',
      subtitle: '',
      ativos: [],
      headerCarteiraSimulada: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
          width: 600,
        },
        {
          text: 'Referência',
          value: 'referencia',
          width: 160,
        },
        {
          text: 'P/L final',
          value: 'aplicacao',
          width: 150,
        },
        {
          text: '%',
          value: 'percent',
        },
        // {
        //   text: '',
        //   value: 'actions',
        // },
      ],
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    GlobalBus.$on(MODAL.SIMULATOR_MORE_INFO, this.open)
  },
  methods: {
    open(ativos, opts = {}) {
      this.ativos = ativos || []
      this.title = opts.title || 'Tabela'
      this.subtitle = opts.subtitle || ''
      this.busModal.$emit('dialog', true)
    },
    sumPL(items, attr = 'Aplicação') {
      return toMoney(
        items.reduce((a, b) => {
          return a + getNumber(b[attr])
        }, 0)
      )
    },
    sumPercent(items) {
      return toPercent(
        items.reduce((a, b) => {
          return a + getNumber(b.percent)
        }, 0)
      )
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="1200">
    <Title :title="title" :subtitle="subtitle" />

    <div>
      <v-data-table
        :headers="headerCarteiraSimulada"
        :items="ativos"
        group-by="classe"
        class="table-new-ux-group-by-v1"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:group.header="{ group, items }">
          <td class="az-text-primary font-semibold"> {{ group }} </td>
          <td></td>
          <td class="az-text-primary font-semibold"> {{ sumPL(items) }} </td>
          <td class="az-text-primary font-semibold"> {{ sumPercent(items) }} </td>
          <!-- <td></td> -->
        </template>
        <template v-slot:item.referencia="{ item }">
          <div>
            {{ item.CNPJ || item.referencia || '' }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div style="width: 78px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon x-small v-on="on" @click="bloquearAtivo">
                  <icon-svg name="mdi-cancel" color="#8E8E8E" size="16" />
                </v-btn>
              </template>
              <span>Bloquear ativo na simulação (não sugerir a compra)</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon x-small v-on="on" @click="trocarAtivo(item)">
                  <icon-svg name="mdi-shuffle-variant" color="#8E8E8E" size="16" />
                </v-btn>
              </template>
              <span>Trocar ativo</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon x-small v-on="on" @click="fixarAtivo">
                  <icon-svg name="mdi-pin-outline" color="#8E8E8E" size="16" />
                </v-btn>
              </template>
              <span>Fixar ativo</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Voltar </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style lang="sass" scope>
.tabela-ativos table
  .v-row-group__header
    background-color: transparent !important
  td
    border-bottom-width: 0px !important
  th
    font-size: 10px !important
    padding-bottom: 00px !important
    height: 30px !important
  td:not(:last-child):not(:first-child), th:not(:last-child):not(:first-child)
    border-left: 1px dashed var(--gray-3)
</style>
